export const environment = {
  production: true,
  firebaseAPIKey:'AIzaSyBDd8KbCczk9azEwjQ5F53pLgAXCEJxkPw',
  apiKey: 'AIzaSyBDd8KbCczk9azEwjQ5F53pLgAXCEJxkPw',
  extraApiKey:'AIzaSyBDd8KbCczk9azEwjQ5F53pLgAXCE',
  authDomain: 'genialii.firebaseapp.com',
  databaseURL: 'https://genialii-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'genialii',
  storageBucket: 'genialii.appspot.com',
  messagingSenderId: '121465787699',
  appId: '1:121465787699:web:a40c170c3ad2a3bd861a46',
  measurementId: 'G-6K2ENV0QM4',
  pages:{
    login:true,
    demo:true,
    signup:true,
    exam:true,
    account:true,
    accountStudent:true,
    competition:true,
    confirm:true,
    paymentconfirmation:true,
    shop:true,
    training:true,
    home:true,
    admin:true
  }
};
